<template>

<div class="col-md-12" v-if="operations.length >= 1 || (type=='payments_and_unallocated' && operations.length ==0)">
    <div class="ibox form">

        <div class="ibox-title ibox-grey">
            <h4>{{ __(tableTitle) }}</h4>
            <button-open-help-modal :help-name="helpName"/>
        </div>

        <div class="ibox-content">
            <div class="scroll-table">
                <div class="table-responsive text-nowrap">
                    <table class="table table-striped main-table">
                        <thead>
                        <tr v-if="type=='payments_and_unallocated'">
                            <th class="th-first">
                                <input type="checkbox" ref="check_all" @click="handleSelectAll">
                            </th>
                            <th>{{ __('payment_date') }}</th>
                            <th>{{ __('contractor') }}</th>
                            <th>{{ __('source_contractor')}}</th>
                            <th>{{ __('payment_source') }}</th>
                            <th class="text-capitalize">{{ __('description') }}</th>
                            <th>{{ __('currency') }}</th>
                            <th class="text-right">{{ __('amount') }}</th>
                            <th class="text-right">{{ __('for_allocation') }}</th>
                            <th class="th-before th-last"></th>
                        </tr>
                        <tr v-else>
                            <th class="th-first">
                                <input type="checkbox" ref="check_all" @click="handleSelectAll">
                            </th>
                            <th>{{ __('payment_date') }}</th>
                            <th>{{ __('payment_source') }}</th>
                            <th>{{ __('source_contractor')}}</th>
                            <th class="text-capitalize">{{ __('description') }}</th>
                            <th>{{ __('currency') }}</th>
                            <th class="text-right">{{ __('amount') }}</th>
                            <th class="text-right">{{ __('for_allocation') }}</th>
                            <th class="th-before th-last"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="type=='payments_and_unallocated'" class="row-show" v-for="(operation, index) in operations" :class="{ 'row-even': index%2 === 0 }">
                            <td class="td-padding">
                                <input type="checkbox" :value="operation.source_id" @change="handleOperationSelect(operation)" :checked="ids.includes(operation.id)">
                            </td>
                            <td class="td-padding">{{ operation.date }}</td>
                            <td class="td-padding"><truncated-text :text="operation.target_contractor" :max_length="55"/></td>
                            <td class="td-padding contractor-table-field text-wrap wrap-text-inside-td">
                                <truncated-text :text="operation.source_contractor" :max_length="55"/>
                            </td>
                            <td class="td-padding text-wrap" style="word-break: break-all">{{ operation.payment_source }}</td>

                            <td class="td-padding text-wrap" style="word-break: break-all">{{ operation.description }}</td>
                            <td class="td-padding">{{ operation.currency }}</td>
                            <td class="td-padding text-right ">{{ operation.operation_amount }}</td>
                            <td class="td-padding text-right">{{ operation.target_amount }}</td>
                            <td class="text-right table-icons">

                                <a v-show="multiple_contractors || history_icon"
                                   v-if="operation.has_access_history"
                                   :href="operation.history_url"
                                   :title="__('contractor_history')"
                                   :data-original-title="__('contractor_history')"
                                   data-toggle="tooltip" data-placement="top" >
                                    <i class="fas fa-share"></i>
                                </a>
                                <a
                                   v-show="operation.source_type ==='OPERATION'"
                                   :href="getShowRoute(operation)"
                                   v-if="operation.has_access_show"
                                   :title="__('show')"
                                   :data-original-title="__('show')"
                                   data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-eye"></i>
                                </a>
                                <a
                                   v-if="operation.has_access_edit"
                                   v-show="operation.source_type ==='OPERATION'"
                                   :href="operation.edit_url+'&returnUrl='+return_url"
                                   :title="__('edit')"
                                   :data-original-title="__('edit')"
                                   data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-pen"></i>
                                </a>
                            </td>
                        </tr>
                        <tr v-if="type=='contractor_history'" class="row-show" v-for="(operation, index) in operations" :class="{ 'row-even': index%2 === 0 }">
                            <td class="td-padding">
                                <input type="checkbox" :value="operation.id" @change="handleOperationSelect(operation)" :checked="ids.includes(operation.id)">
                            </td>
                            <td class="td-padding">{{ operation.date }}</td>
                            <td class="td-padding text-wrap" style="word-break: break-all">{{ operation.payment_source }}</td>
                            <td class="td-padding contractor-table-field text-wrap wrap-text-inside-td">
                                <truncated-text :text="operation.source_contractor" :max_length="55"/>
                            </td>

                            <td class="td-padding text-wrap" style="word-break: break-all">{{ operation.description }}</td>
                            <td class="td-padding">{{ operation.currency }}</td>
                            <td class="td-padding text-right ">{{ operation.operation_amount }}</td>
                            <td class="td-padding text-right">{{ operation.target_amount }}</td>
                            <td class="text-right table-icons">

                                <a v-show="multiple_contractors"
                                   :href="operation.history_url"
                                   :title="__('contractor_history')"
                                   :data-original-title="__('contractor_history')"
                                   data-toggle="tooltip" data-placement="top" >
                                    <i class="fas fa-share"></i>
                                </a>
                                <a
                                    v-if="operation.has_access_show"
                                    v-show="operation.source_type ==='OPERATION'"
                                    :href="getShowRoute(operation)"
                                    :title="__('show')"
                                    :data-original-title="__('show')"
                                    data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-eye"></i>
                                </a>
                                <a
                                    v-if="operation.has_access_edit"
                                    v-show="operation.source_type ==='OPERATION'"
                                    :href="operation.edit_url+'&returnUrl='+return_url"
                                    :title="__('edit')"
                                    :data-original-title="__('edit')"
                                    data-toggle="tooltip" data-placement="top">
                                    <i class="fa fa-pen"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="type=='contractor_history' && allow_export == getPermission('export_contractor_history_operation') && !contractorHistoryOperationExportDisabled" class="ibox-content">
            <bulk-action  :url="bulkUrl" table="operations" :ids="bulkIds" param="operation_id" :table_title="tableTitle" ></bulk-action>
        </div>
        <div v-if="type=='contractor_history' && allow_export == getPermission('export_contractor_history_operation') && contractorHistoryOperationExportDisabled" class="ibox-content">
            <div>
                {{ __('with_selected') }}:
                <button data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle" disabled="">
                    {{ __('export') }}
                </button>
            </div>
        </div>
        <div v-else-if="type=='payments_and_unallocated' &&  allow_export" class="ibox-content">
            <bulk-action  v-if="!contractorHistoryOperationExportDisabled" :url="bulkUrl" table="operations" :ids="bulkIds" param="operation_id" :table_title="tableTitle"></bulk-action>
            <div v-else>
                {{ __('with_selected') }}:
                <button data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle" disabled="">
                    {{ __('export') }}
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import events from '../../services/Events.js'
    import tooltips from '../../mixins/hasTooltips.js'
    import permissions from '../../services/Permissions.js'
    import HelpModal from '../help/HelpModal.vue';
    import ButtonOpenHelpModal from '../help/ButtonOpenHelpModal.vue';

    export default {
        name: 'operations-history',
        mixins: [tooltips],
        data: function () {
            return {
                ids: []
            }
        },
        components : {
            HelpModal,
            ButtonOpenHelpModal
        },
        methods: {
            getShowRoute(operation){
                if(operation.show_url.includes('records/payments'))
                {
                    return operation.show_url+'?returnUrl='+ this.return_url
                }
               return operation.show_url+'&returnUrl='+ this.return_url
            },
            handleOperationSelect: function(operation) {
                this.$emit('disableButtons')
                if (event.target.checked) {
                    this.selectOperation(operation);
                } else {
                    this.removeOperation(operation);
                    this.removeSelectAll();
                }
            },
            removeSelectAll: function() {
                this.$refs['check_all'].checked  = false;
            },
            selectOperation: function(operation) {
                if(this.ids.indexOf(operation.id) < 0) this.ids.push(operation.id);
                this.$store.commit('selectOperation', operation.id);
                this.$store.commit('addSelected', operation)
            },
            removeOperation: function(operation) {
                if(this.ids.indexOf(operation.id) >= 0) this.ids.splice(this.ids.indexOf(operation.id), 1);
                this.$store.commit('removeOperation', operation.id);
                this.$store.commit('removeSelected', operation);
            },
            handleSelectAll: function() {
                if(event.target.checked) {
                    this.selectAll();
                } else if (!event.target.checked) {
                    this.clearSelected();
                }
            },
            clearSelected: function() {
                this.operations.forEach(operation => {
                    this.removeOperation(operation);
                })
            },
            selectAll: function() {
                this.operations.forEach(operation => {
                    this.selectOperation(operation);
                })
            },
            handleResponseSuccess: function(response) {
                this.$emit('change', {
                    props: this.$props,
                    message: response.data.message
                })
            },
            handleResponseFail: function(error) {
                console.log(error.response.data.message);
                toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
            },
            destroy: function(operation) {
                this.axios.delete(operation.destroy_url)
                    .then(response => this.handleResponseSuccess(response))
                    .catch(error => this.handleResponseFail(error));
            },
            getOperationParentOrSelf: function(operation) {
                return this.$store.getters.getOperationParentOrSelf(operation)
            },
            getOperationRootOrSelf: function(operation) {
                return this.$store.getters.getOperationRootOrSelf(operation)
            },
            editUrl: function (operation) {
                return operation.is_department_transfer ? operation.edit_url + '&return=' + location : operation.edit_url + '?return=' + location
            },
            showUrl: function (operation) {
                return operation.is_department_transfer ? operation.show_url + '&return=' + location : operation.show_url + '?return=' + location
            },
            getPermission: function(permission) {
                return permissions.getPermission(this.permission_access, permission);
            },
        },
        props: [
            'allow_export', 'operations', 'contractor_id', 'index', 'multiple_contractors', 'permission_access', 'bulkActionUrl', 'table_title', 'helpName', 'return_url', 'type', 'history_icon'
        ],
        mounted: function() {
            const reset = () => {
                this.clearSelected();
                if(this.$refs['check_all']) this.$refs['check_all'].checked = false
            };

            events.$on('modalGenerateBalance:saved', reset);
            events.$on('modalConnectWith:saved', reset);
            events.$on('modalConnectWith:hide', reset)

        },
        computed: {
            tableTitle : function (){return this.$props.table_title ?? 'unallocated_payments' },
            location: function() { return location.pathname },
            bulkUrl: function() { return this.$props.bulkActionUrl ?? '/summaries/contractor-history/' + this.contractor_id + '/bulk-action' },
            bulkIds: function() { return this.ids },
            contractorHistoryOperationExportDisabled: function (){
                const _this = this;
                let hasAccess = true;
                let checked = this.operations.filter(function (item){
                    return _this.ids.includes(item.id)
                })
                if(checked.length == 0){
                    return false;
                }
                checked.forEach(operation => {
                   if(!operation.has_access_export){
                       hasAccess = false;
                   }
                })
                if(hasAccess){
                    return false;
                }
                else{
                    return true;
                }
            }
        }
    }
</script>

<style scoped>
    .check-all {
        z-index: 1;
    }

    .contractor-table-field{
        max-width: 100px;
    }
</style>
